<template>
  <!-- ユーザ編集 -->
  <div id="AppUserManagementEditUserContents">
    <template :data="data">
      <!-- 上部余白 -->
      <div style="height: 10px;" />
      <!--ユーザ情報 -->
      <b-field
        label="点検担当者コード"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('staffCode')}"
        :message="errors.first('staffCode')"
      >
        <b-input
          v-if="isEdit"
          v-model="data.staffCode"
          :readonly="checkDisabled(staffCode)"
          name="staffCode"
          data-vv-as="点検担当者コード"
          v-validate="'alphaUpper_num|max:5'"
          maxlength="5"
        ></b-input>
        <b-input v-else :value="data.staffCode" :readonly="true"></b-input>
      </b-field>
      <b-field
        label="姓"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('lastName')}"
        :message="errors.first('lastName')"
      >
        <b-input
          v-if="isEdit"
          v-model="data.lastName"
          name="lastName"
          data-vv-as="姓"
          v-validate="'required|max:50'"
          maxlength="50"
        ></b-input>
        <b-input v-else :value="data.lastName" :readonly="true"></b-input>
      </b-field>
      <b-field
        label="姓（カナ）"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('lastNameKana')}"
        :message="errors.first('lastNameKana')"
      >
        <b-input
          v-if="isEdit"
          v-model="data.lastNameKana"
          name="lastNameKana"
          data-vv-as="姓（カナ）"
          v-validate="'required|katakana|max:50'"
          maxlength="50"
        ></b-input>
        <b-input v-else :value="data.lastNameKana" :readonly="true"></b-input>
      </b-field>
      <b-field
        label="名"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('firstName')}"
        :message="errors.first('firstName')"
      >
        <b-input
          v-if="isEdit"
          v-model="data.firstName"
          name="firstName"
          data-vv-as="名"
          v-validate="'required|max:50'"
          maxlength="50"
        ></b-input>
        <b-input v-else :value="data.firstName" :readonly="true"></b-input>
      </b-field>
      <b-field
        label="名（カナ）"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('firstNameKana')}"
        :message="errors.first('firstNameKana')"
      >
        <b-input
          v-if="isEdit"
          v-model="data.firstNameKana"
          name="firstNameKana"
          data-vv-as="名（カナ）"
          v-validate="'required|katakana|max:50'"
          maxlength="50"
        ></b-input>
        <b-input v-else :value="data.firstNameKana" :readonly="true"></b-input>
      </b-field>
      <b-field label="営業所" labelPosition="on-border">
        <b-select v-if="isEdit" expanded v-model="selectedOffice">
          <option
            v-for="office in officeMaster"
            :value="office.officeCode"
            :key="office.officeCode"
          >{{ office.officeName }}</option>
        </b-select>
        <b-input v-else :value="getOfficeName(selectedOffice)" :readonly="true"></b-input>
      </b-field>
      <b-field label="電話番号(直通)" labelPosition="on-border">
        <b-input v-model="data.officePhoneNumber" :readonly="true"></b-input>
      </b-field>
      <b-field
        label="電話番号(携帯)"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('mobilePhoneNumber')}"
        :message="errors.first('mobilePhoneNumber')"
      >
        <b-input
          v-if="isEdit"
          v-model="data.mobilePhoneNumber"
          name="mobilePhoneNumber"
          data-vv-as="電話番号(携帯)"
          v-validate="'max:20'"
        ></b-input>
        <b-input v-else :value="data.mobilePhoneNumber" :readonly="true"></b-input>
      </b-field>
      <b-field
        label="メールアドレス"
        labelPosition="on-border"
        :type="{'is-danger':errors.has('email')}"
        :message="errors.first('email')"
      >
        <b-input v-model="data.email" :readonly="true"></b-input>
      </b-field>
      <b-field label="権限" labelPosition="on-border">
        <b-select v-if="isEdit" xpanded="true" expanded v-model="data.role" name="role">
          <option value="4">点検者</option>
          <option value="3">点検管理者</option>
          <option value="5">GSS管理者</option>
          <option value="6">営業管理者</option>
          <option value="2">コールセンター</option>
          <option value="7">待機当番のみ</option>
          <option value="1">システム管理者</option>
        </b-select>
        <b-input v-else :value="roleFilter(data.role)" :readonly="true"></b-input>
      </b-field>
      <b-field label="役職" labelPosition="on-border">
        <b-select v-if="isEdit" expanded v-model="selectedPosition">
          <option
            v-for="position in positionMaster"
            :value="position.positionCode"
            :key="position.positionCode"
          >{{ position.positionName }}</option>
        </b-select>
        <b-input v-else :value="data.positionName" :readonly="true"></b-input>
      </b-field>
      <b-field
        v-if="!isEdit"
        label="参照可能営業所"
        labelPosition="on-border"
        :rowspan="referenceOffice.length"
      >
        <b-input
          v-if="data.role==3||data.role==4||data.role==5"
          :rows="referenceOffice.length"
          resize="none"
          type="textarea"
          :value="getReferenceOfficeName(referenceOffice)"
          :readonly="true"
        ></b-input>
        <b-input v-else value="全営業所" :readonly="true"></b-input>
      </b-field>
      <!-- 下部余白 -->
      <div style="height: 10px;" />
    </template>
  </div>
</template>

<script>
var data = [];
var officeMaster = [];
var positionMaster = [];
export default {
  name: "AppUserManagementEditUserContents",
  props: ["isSaveComplete", "selectedid", "isEdit"],
  methods: {
    getReferenceOfficeName: function(list) {
      var result = "";
      for (var item in list) {
        var officeElement = this.officeMaster.find(
          v => v.officeCode === list[item].officeCode
        );
        if (officeElement) {
          result =
            result.length == 0
              ? officeElement.officeName
              : result + "\r\n" + officeElement.officeName;
        }
      }

      return result;
    },
    getOfficeName: function(value) {
      var officeElement = this.officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    checkDisabled: function(code) {
      if (code != null) {
        code = code.replace(" ", "").replace("　", "");
      }
      if (code == null || code == "") {
        return false;
      }
      return true;
    },
    load: function() {
      var excuteApi = this.getUserListPOST;
      var successCallBack = this.getUserListSuccess;
      var errorCallBack = this.getUserListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getUserListPOST: function(client) {
      return client.apis.apiMaster.getUserListPOST({
        body: {
          id: this.selectedid
        }
      });
    },
    getUserListSuccess: function(result) {
      var apiRet = result.obj;
      var userInfo = apiRet[0];
      this.data = userInfo;
      this.staffCode = this.data.staffCode;
      this.selectedOffice = this.data.officeCode;
      this.selectedPosition = this.data.positionCode;
    },
    getUserListError: function(error) {
      this.showErrorMessage(error);
    },
    //ユーザ情報更新
    update: function() {
      var excuteApi = this.setUserInfoPOST;
      var successCallBack = this.setUserInfoPOSTSuccess;
      var errorCallBack = this.setUserInfoPOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setUserInfoPOST: function(client) {
      return client.apis.apiMaster.setUserInfoPOST({
        body: {
          id: this.data.id,
          code: this.data.staffCode,
          lastName: this.data.lastName,
          lastNameKana: this.data.lastNameKana,
          firstName: this.data.firstName,
          firstNameKana: this.data.firstNameKana,
          officeCode: this.data.officeCode,
          officePhoneNumber: this.data.officePhoneNumber,
          mobilePhoneNumber: this.data.mobilePhoneNumber,
          positionCode: this.data.positionCode,
          email: this.data.email,
          role: parseInt(this.data.role)
        }
      });
    },
    setUserInfoPOSTSuccess: function(result) {
      this.showSuccess(result);
      this.updateSuccess = true;
    },
    setUserInfoPOSTError: function(result) {
      this.updateSuccess = false;
      this.showErrorMessage(result);
    },
    isSuccessEnd: function() {
      return this.updateSuccess;
    },
    officePhoneFilter: function(value) {
      var officeElement = this.officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.phoneNumber;
      }
      return "";
    },
    validation: function(event) {
      // バリデータイベント
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$props.isSaveComplete = true;
        } else {
          scrollTo(0, 0);
        }
      });
    }
  },
  data() {
    officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    positionMaster = JSON.parse(sessionStorage.getItem("positionMaster"));
    var referenceOffice = JSON.parse(
      sessionStorage.getItem("referenceEnableOffice")
    );
    return {
      data,
      staffCode: "",
      updateSuccess: false,
      selectedOffice: "",
      selectedPosition: "",
      officeMaster,
      positionMaster,
      referenceOffice
    };
  },
  watch: {
    selectedOffice(value) {
      this.data.officeCode = value;
      this.data.officePhoneNumber = this.officePhoneFilter(value);
    },
    selectedPosition(value) {
      this.data.positionCode = value;
    }
  },
  computed: {
    roleFilter: function(value) {
      return function(value) {
        if (value === 7) {
          return "待機当番のみ";
        } else if (value === 6) {
          return "営業管理者";
        } else if (value === 5) {
          return "GSS管理者";
        } else if (value === 4) {
          return "点検者";
        } else if (value === 3) {
          return "点検管理者";
        } else if (value === 2) {
          return "コールセンター";
        } else if (value === 1) {
          return "システム管理者";
        }
      };
    }
  },
  mounted: function() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/AppUserManagementEditUserContents.vue